import { Button, Grid, Paper, TableFooter, TablePagination } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme, withStyles
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Edit } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
    getTicket,
    UpdateStatusClosed,
} from "../../actions/GenomicsResearchAction";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        paper: {
            marginTop: "2rem",
            padding: "0.5rem 2rem 2rem 2rem",
            width: "100%",
        },
        hoveItem: {
            cursor: "pointer",
        },
        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        text: { color: "black" },
    })
);

const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#12145e",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);
interface Props {
    getTicket: any;
    fetchTickets: any;
    UpdateStatusClosed: any;
}
const StopsPlace: React.FC<Props> = ({
    getTicket,
    fetchTickets,
    UpdateStatusClosed,

}) => {
    const classes = useStyles();
    const [page, setPage] = useState(0);
    const history = useHistory();


    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
    ) => {
        if (newPage > page) {
            let url = fetchTickets?.links && fetchTickets?.links.next.split("?")[1];
            getTicket(url);
        } else if (newPage < page) {
            let url = fetchTickets?.links && fetchTickets?.links.previous.split("?")[1];
            getTicket(url);
        }
        setPage(newPage as number);
    };

    useEffect(() => {
        getTicket();
    }, [])

    const handleDataFullfill = (id: any) => {
        dialogBox(id);
    };

    const dialogBox = (getId: any) => {
        let text = "Are You Sure You Want To Closed This Ticket?";
        if (window.confirm(text) === true) {
            text = "Yes";
            UpdateStatusClosed({ data: "" }, getId);
            setTimeout(() => {
                getTicket();
            }, 1000);
        } else {
            text = "No";
        }
    }


    return (
        <Grid container spacing={2} style={{ marginTop: 80 }}>
            <Grid item xs={12}>
                <Link
                    to={`/dashboard/gnre/createTicket/create`}
                    style={{ textDecoration: "none" }}
                >
                    <Button
                        variant="contained"
                        style={{ marginLeft: "1rem", backgroundColor: "#0E5E6F", color: "white" }}
                    >
                        Create New Ticket
                    </Button>
                </Link>
            </Grid>
            <Grid container>
                <TableContainer
                    className={classes.tableContainer}
                    component={Paper}
                    style={{ maxHeight: "580px" }}
                >
                    <Table stickyHeader aria-label="simple table">
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="center">
                                    Ticket Status
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    Subject
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    Assign To
                                </StyledTableCell><StyledTableCell align="center">
                                    Type
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    Created Date
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    project Id
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    Action
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    Closed Status
                                </StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {fetchTickets && fetchTickets?.results && fetchTickets?.results?.length > 0 && fetchTickets?.results?.map((data: any, index: any) => {
                                return (
                                    <StyledTableRow >
                                        <StyledTableCell align="center" style={{ background: data?.status === "Closed" ? "#1b802c" : "" }}>
                                            {data?.status}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.subject}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.assignTo?.length > 0 && data?.assignTo?.map((val: any) => val?.fullname).join(",")}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.type}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.createdAt !== null ? new Date(data?.createdAt).toLocaleString() : ""}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.project?.projectId}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            <StyledTableCell align="center">
                                                <Button
                                                    color="primary"
                                                    variant="contained"
                                                    // disabled={data?.status === "Closed"}
                                                    onClick={() =>
                                                        history.push(
                                                            `/dashboard/gnre/createTicket/${data._id}`
                                                        )
                                                    }
                                                >
                                                    Respond
                                                </Button>
                                            </StyledTableCell>
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            <Button
                                                onClick={() => handleDataFullfill(data?._id)}
                                                variant="contained"
                                                disabled={data?.status === "Closed"}
                                                style={{
                                                    backgroundColor: "#14999c",
                                                    color: "#fff",
                                                }}
                                            >
                                                Closed Status
                                            </Button>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )
                            })}
                        </TableBody>
                        <TableFooter>
                            <TablePagination
                                rowsPerPageOptions={[]}
                                colSpan={3}
                                count={fetchTickets?.count || 0}
                                rowsPerPage={fetchTickets?.page_size}
                                page={page}
                                onPageChange={handleChangePage}
                            />
                        </TableFooter>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    );
};
const mapStateToProps = (state: any) => ({
    dealer: state.GenomicsCAReducer.dealer,
    fetchTickets: state.GenomicsCAReducer.fetchTickets,
});
export default connect(mapStateToProps, {
    getTicket,
    UpdateStatusClosed,
})(StopsPlace);
